import { Text } from '@/ui'
import { mtc, TextColors, TypographyStyles } from '@/styles'
import { Sparkles } from '@/features/adviser-chat/components/Sparkles'

interface WelcomeHeroProps {
  firstName?: string
  illustrationClassName?: string
}

export const WelcomeHero = ({
  firstName,
  illustrationClassName,
}: WelcomeHeroProps) => (
  <div className="flex flex-col items-center text-center">
    <Sparkles className={mtc('mb-5', illustrationClassName)} />
    <Text variant={TypographyStyles.DISPLAY_XS} className="mb-3">
      {firstName ? `How can we help, ${firstName}?` : 'How can we help?'}
    </Text>
    <Text
      variant={TypographyStyles.BODY_MD}
      color={TextColors.MUTED}
      className="text-center"
    >
      Ask about taxes, bookkeeping, payroll, or planning.
    </Text>
  </div>
)
